<template>
    <div class="state-display">
      <icon :type="state" />
      <icon v-if="state === 'p'" type="clock" />
      <icon v-else-if="state === 'a'" type="eye" />
      <icon v-else-if="state === 'i'" type="ban" />
      <icon v-else-if="state === 'h'" type="eye-slash" />
      </div>
</template>

<script>
import Icon from "./Icon";
export default {
  name: "StateSetter",
  components: {
    Icon
  },
  props: {
    state: {type: String, required: true},
  }
}
</script>

<style lang="scss">
  .state-display {
    width: 22px;
    height: 20px;
    position:relative;
    border-radius: 2px;
    opacity: 0.5;
    .icon {
      position:absolute;
      top: 50%;
      left: 50%;
      -webkit-transform: translate(-50%,-50%);
      transform: translate(-50%,-50%);
    }
    &.bright {
      background-color: rgba(255,255,255,0.5);
      color: #000;
    }
  }
</style>